import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

//根据权限获取到的路由
export const routeList = [{
  id:'1',
  name:'合同管理',
  index:'1',
  childrens:[{
    path:'/Contract',
    name:'委托申请',
    component:()=>import('../views/Contract/Contract.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/ContractSearch',
    name:'检索查新委托申请',
    component:()=>import('../views/Contract/ContractSearch.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/StateContract/0',
    name:'等待审核',
    component:()=>import('../views/Contract/StateContract.vue'),
    meta:{
      isRequire:true,
      param:{
        state:0
      }
    }
  },{
    path:'/StateContract/1',
    name:'已通过',
    component:()=>import('../views/Contract/StateContractV2.vue'),
    meta:{
      isRequire:true,
      param:{
        state:1
      }
    }
  },{
    path:'/StateContract/2',
    name:'未通过',
    component:()=>import('../views/Contract/StateContractV1.vue'),
    meta:{
      isRequire:true,
      param:{
        state:2
      }
    }
  },{
    path:'/StateContract/3',
    name:'草稿箱',
    component:()=>import('../views/Contract/StateContractV2.vue'),
    meta:{
      isRequire:true,
      param:{
        state:3
      }
    }
  }]
},{
  id:'2',
  name:'服务报告管理',
  childrens:[{
    path:'/WaitReport',
    name:'等待分配',
    component:()=>import('../views/ServiceReport/WaitReport.vue'),
    meta:{
      isRequire:true
    }
  },{
    id:'2-1',
    name:'第一操作员',
    index:'2-1',
    children:[{
      path:'/MyServerV1',
      name:'我的服务项目',
      component:()=>import('../views/ServiceReport/MyServerV1.vue'),
      meta:{
        isRequire:true
      }
    },{
      path:'/MyUpdateV1',
      name:'我的退修项目',
      component:()=>import('../views/ServiceReport/MyUpdateV1.vue'),
      meta:{
        isRequire:true
      }
    },{
      path:'/AllServerV1',
      name:'所有一审项目',
      component:()=>import('../views/ServiceReport/AllServerV1.vue'),
      meta:{
        isRequire:true
      }
    }]
  },{
    id:'2-2',
    name:'第二操作员',
    index:'2-2',
    children:[{
      path:'/MyServerV2',
      name:'我的服务项目',
      component:()=>import('../views/ServiceReport/MyServerV2.vue'),
      meta:{
        isRequire:true
      }
    },{
      path:'/MyUpdateV2',
      name:'我的退修项目',
      component:()=>import('../views/ServiceReport/MyUpdateV2.vue'),
      meta:{
        isRequire:true
      }
    },{
      path:'/AllServerV2',
      name:'所有二审项目',
      component:()=>import('../views/ServiceReport/AllServerV2.vue'),
      meta:{
        isRequire:true
      }
    }]
  },{
      id:'2-3',
      name:'审核员',
      index:'2-3',
      children:[{
        path:'/FinishJudg',
        name:'我的终审项目',
        component:()=>import('../views/ServiceReport/FinishJudg.vue'),
        meta:{
          isRequire:true
        }
      },{
        path:'/MyUpdateFinishJudg',
        name:'我的退休终审项目',
        component:()=>import('../views/ServiceReport/MyUpdateFinishJudg.vue'),
        meta:{
          isRequire:true
        }
      },{
        path:'/AllJudg',
        name:'所有终审项目',
        component:()=>import('../views/ServiceReport/AllJudg.vue'),
        meta:{
          isRequire:true
        }
      }]
  },{
    id:'2-4',
    name:'检测员',
    index:'2-4',
    children:[{
      path:'/MyServerInspector',
      name:'我的检测项目',
      component:()=>import('../views/ServiceReport/MyServerInspector.vue'),
      meta:{
        isRequire:true
      }
    },{
      path:'/AllInspector',
      name:'所有检测项目',
      component:()=>import('../views/ServiceReport/AllInspector.vue'),
      meta:{
        isRequire:true
      }
    }]
}]
},{
  id:'6',
  name:'所有服务项目',
  index:'6',
  childrens:[{
    path:'/ServeiceProject',
    name:'所有服务项目',
    component:()=>import('../views/ServeiceProject/ServeiceProject.vue'),
    meta:{
      isRequire:true
    }
  }]
},{
  id:'3',
  name:'费用管理',
  index:'3',
  childrens:[{
    path:'/PaymentItems',
    name:'所有缴费项目',
    component:()=>import('../views/Expense/PaymentItems.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/LaborCost',
    name:'工时费',
    component:()=>import('../views/Expense/LaborCost.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/OrderList',
    name:'我的订单',
    component:()=>import('../views/Expense/OrderList.vue'),
    meta:{
      isRequire:true
    }
  }]
},{
  id:'4',
  name:'报告领取',
  index:'4',
  childrens:[{
    path:'/ReportCollection',
    name:'报告',
    component:()=>import('../views/Report/ReportCollection.vue'),
    meta:{
      isRequire:true
    }
  }]
},{
  id:'5',
  name:'用户评价',
  index:'5',
  childrens:[{
    path:'/Evaluate',
    name:'评价',
    component:()=>import('../views/Evaluate/Evaluate.vue'),
    meta:{
      isRequire:true
    }
  }]
},{
  id:'7',
  name:'工作站',
  index:'7',
  childrens:[{
    path:'/Workstation',
    name:'工作站设置',
    component:()=>import('../views/Workstation/workstation.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/Operator',
    name:'操作员管理',
    component:()=>import('../views/Workstation/Operator.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/Entrusted',
    name:'委托用户管理',
    component:()=>import('../views/Workstation/Entrusted.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/ServeType',
    name:'服务类型',
    component:()=>import('../views/Workstation/ServeType.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/Inspector',
    name:'检测员管理',
    component:()=>import('../views/Workstation/inspector.vue'),
    meta:{
      isRequire:true
    }
  }]
},{
  id:'8',
  name:'个人设置',
  index:'8',
  childrens:[{
    path:'/UpdateInfo',
    name:'修改信息',
    component:()=>import('../views/PeopleSetting/updateInfo.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/UpdatePwd',
    name:'修改密码',
    component:()=>import('../views/PeopleSetting/updatePwd.vue'),
    meta:{
      isRequire:true
    }
  }]
},{
  id:11,
  name:'我的钱包',
  index:'11',
  childrens:[{
    name:'余额',
    path:'/MyMoney',
    component:()=>import('@/views/MyMoney/money'),
    meta:{
      isRequire:true
    }
  }]
},{
  id:10,
  name:'功能模块',
  index:'10',
  childrens:[{
    name:'功能',
    path:'/Module',
    component:()=>import('@/views/Module/module'),
    meta:{
      isRequire:true
    }
  },{
    name:'权限',
    path:'/Role',
    component:()=>import('@/views/Module/role'),
    meta:{
      isRequire:true
    }
  }]
},{
  id:11,
  name:'发票',
  index:'11',
  childrens:[{
    name:'发票',
    path:'/Invoice',
    component:()=>import('@/views/invoice/invoice')
  }]
},{
  id:12,
  name:'退款',
  index:12,
  childrens:[{
    name:'退款列表',
    path:'/refund',
    component:()=>import('@/views/Refund/refund')
  }]
}]

//首页路由
export const homeRoute = {
  path: '/',
    name: 'home',
    component: HomeView,
    meta: { 
      isRequire:true
    },
    children:[]
}

routeList.forEach(s=>{
  s.childrens.forEach(pp=>{
    // homeRoute.children.push(...pp);
    if(pp.children == null){
      homeRoute.children.push(pp);
    }else{
      pp.children.forEach(cc=>{
        homeRoute.children.push(cc);
      })
    }
  })
})
console.log(homeRoute)

//公共路由
export const routes = [
  {
    path:'*',
    name:'error',
    component:()=>import('../views/404.vue')
  },{
    path:'/login',
    name:'login',
    component:()=>import('../views/Login/Login.vue'),
    meta: { 
      isRequire:false
    }
  },{
    path:'/registerServe',
    name:'registerServe',
    component:()=>import('../views/Login/RegisterServe.vue'),
    meta:{
      isRequire:false
    }
  },{
    path:'/registerSites',
    name:'registerSites',
    component:()=>import('../views/Login/RegisterSites.vue'),
    meta:{
      isRequire:false
    }
  },{
    path:'/payPage/:id',
    name:'pay',
    component:()=>import('../views/CommonPage/pay.vue'),
    meta:{
      isRequire:true
    }
  },{
    path:'/refundPage/:id',
    name:'refund',
    component:()=>import('../views/CommonPage/refund.vue'),
    meta:{
      isRequire:true
    }
  }
]

routes.push(homeRoute)

const router = new VueRouter({
  // mode: 'history',
  mode:'hash',
  base: process.env.BASE_URL,
  routes
})
export default router
